/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  ChangeResourceExecutionStatusInput,
  useChangeResourceExecutionStatusMutation,
} from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";
import { RefetchOptions, refetchQueryHelper } from "../../helpers";

type Props = {
  onSuccess: () => void;
};

export function useChangeResourceExecutionStatus({ onSuccess }: Props) {
  const [changeResourceExecutionStatusMutation, { loading }] =
    useChangeResourceExecutionStatusMutation({
      onCompleted: () => {
        onSuccess();
        showSuccess(
          generateActionSuccessText("Resource Execution Status")()("changed")()
        );
      },
      onError: (error: Error) => showError(error.message),
      refetchQueries: [refetchQueryHelper(RefetchOptions.EVENT)],
    });

  async function changeResourceExecutionStatus(
    changeResourceStatusDetails: ChangeResourceExecutionStatusInput
  ) {
    await changeResourceExecutionStatusMutation({
      variables: { input: changeResourceStatusDetails },
    });
  }

  return { changeResourceExecutionStatus, loading } as const;
}
